module.exports = __webpack_public_path__ + "img/img7.91b37eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lifeHome/img7.png
// module id = 400
// module chunks = 0